import React, { useState } from 'react';
import axios from 'axios';
import { TrendingDown, CheckCircle2, Loader2 } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { usePageT } from '../i18n/usePageT';
import { useAuth } from '../contexts/AuthContext';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PriceWatchButton = ({ productId }) => {
  const { language } = useLanguage();
  const T = usePageT();
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState(user?.email || '');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubmitting(true);
    try {
      const r = await axios.post(`${API}/products/${productId}/price-watch`, {
        email: email.trim(),
        language,
      });
      setDone(true);
      toast.success(
        r.data.status === 'already_subscribed'
          ? T('Vous suivez déjà le prix de ce produit ✓', 'You are already watching this price ✓')
          : T('Alerte prix activée ! Nous vous préviendrons en cas de baisse.', 'Price alert on! We will email you if it drops.')
      );
    } catch (err) {
      toast.error(err.response?.data?.detail || T('Erreur', 'Error'));
    } finally {
      setSubmitting(false);
    }
  };

  if (done) {
    return (
      <div className="inline-flex items-center gap-2 text-sm text-emerald-700 font-medium" data-testid="price-watch-confirmed">
        <CheckCircle2 className="w-4 h-4" />
        {T('Alerte prix activée — nous vous préviendrons par email', 'Price alert on — we will email you')}
      </div>
    );
  }

  if (!open) {
    return (
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#0F4C5C] hover:text-[#E9C46A] transition-colors"
        data-testid="price-watch-btn"
      >
        <TrendingDown className="w-4 h-4" />
        {T('M\'alerter si le prix baisse', 'Alert me if the price drops')}
      </button>
    );
  }

  return (
    <form onSubmit={submit} className="flex items-center gap-2 max-w-md" data-testid="price-watch-form">
      <Input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder={T('votre@email.com', 'your@email.com')}
        className="h-9"
        data-testid="price-watch-email-input"
      />
      <Button type="submit" size="sm" disabled={submitting} className="btn-primary shrink-0 h-9" data-testid="price-watch-submit-btn">
        {submitting ? <Loader2 className="w-4 h-4 animate-spin" /> : T('M\'alerter', 'Notify me')}
      </Button>
    </form>
  );
};
